import HeroSection from '@/components/HeroSection'
import NewsletterSection from '@/components/NewsletterSection'
import BlogCard from '@/components/BlogCard'
import Link from 'next/link'

const aboutSections = [
  { label: 'Inspiration', href: '/about/inspiration' },
  { label: 'Mission', href: '/about/mission' },
  { label: 'Vision', href: '/about/vision' },
  { label: 'Bio', href: '/about/bio' },
  { label: 'Core Values', href: '/about/core-values' },
  { label: 'Contact', href: '/about/contact' },
]

export default function AboutBio() {
  const stats = [
    { icon: '🤝', value: '+25', label: 'YEARS EXPERIENCE' },
    { icon: '👥', value: '+1000', label: 'PEOPLE I WORK WITH' },
    { icon: '🚀', value: '+60', label: 'ALL PROJECTS' },
  ]

  const blogPosts = [
    {
      id: '1',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
      date: '24/08/2024',
      category: 'Travel',
      likes: 23,
      comments: 5,
    },
    {
      id: '2',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
      date: '24/08/2024',
      category: 'Travel',
      likes: 23,
      comments: 5,
    },
    {
      id: '3',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
      date: '24/08/2024',
      category: 'Travel',
      likes: 23,
      comments: 5,
    },
  ]

  return (
    <>
      {/* Hero */}
      <HeroSection
        variant="blue"
        title="MR. ALRIFAI BIO"
        imageUrl="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop"
      />

      {/* About Navigation */}
      <section className="py-8 bg-background border-b border-border">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap gap-4 justify-center md:justify-start">
            {aboutSections.map((section) => (
              <Link
                key={section.href}
                href={section.href}
                className={`px-4 py-2 rounded font-medium transition-colors ${
                  section.href === '/about/bio'
                    ? 'bg-accent text-accent-foreground'
                    : 'text-foreground hover:text-accent'
                }`}
              >
                {section.label}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Bio Section */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-foreground mb-6 text-balance">
            ABOUT GHASSAN.
          </h2>

          <div className="grid md:grid-cols-2 gap-12 mb-16">
            {/* Video */}
            <div className="relative aspect-video bg-card border border-border rounded-lg overflow-hidden flex items-center justify-center group cursor-pointer">
              <img
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop"
                alt="Video Thumbnail"
                className="w-full h-full object-cover group-hover:opacity-75 transition-opacity"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/50 transition-colors">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-accent" size={64} />
              </div>
            </div>

            {/* Bio Text */}
            <div>
              <p className="text-muted-foreground text-lg mb-6 leading-relaxed">
                Ghassan Alfifai Is An Experienced Entrepreneur In Business Development And Strategic Planning, Focusing On Collaboration, Growth, And Innovation. His Ideals At Turning Challenges Into Opportunities And Aims To Build Strong Partnerships And Support Startups For A Better Future.
              </p>
              <p className="text-muted-foreground text-lg mb-8 leading-relaxed">
                Ghassan Alfifai, a visionary entrepreneur and strategic business leader with deep expertise in technology, sales, and strategic planning, has consistently delivered comprehensive solutions that drive measurable business growth. With over 25 years in the industry, Ghassan has successfully managed and expanded numerous business ventures.
              </p>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-4">
                {stats.map((stat, idx) => (
                  <div key={idx} className="border border-border rounded-lg p-4 text-center hover:border-accent transition-colors">
                    <div className="text-3xl mb-2">{stat.icon}</div>
                    <div className="text-xl font-bold text-accent mb-1">{stat.value}</div>
                    <div className="text-xs text-muted-foreground">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Professional Career */}
          <div className="bg-card border border-border rounded-lg p-8">
            <h3 className="text-2xl font-bold text-foreground mb-4">
              Professional Career: A Trailblazer in Multiple Industries
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              Ghassan&apos;s professional career commenced in 2004 in Qatar, where he gained extensive experience across diverse industries. His roles included managing servers for prestigious accounts like the Qatar Foundation and Qatar TV at BP, excelling in automobile sales at Q Maroc, and serving as a Business Development Officer at three different companies. Throughout his career, Ghassan has demonstrated a deep appreciation for the past and an unwavering commitment to collaboration and leadership innovation to Empower Future Innovators.
            </p>
          </div>
        </div>
      </section>

      {/* Follow Section */}
      <section className="py-20 bg-secondary">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            FOLLOW GHASSAN.
          </h2>
          <p className="text-muted-foreground mb-8 max-w-2xl mx-auto">
            Discover How Embracing The Strength Of Unity Can Elevate Us To Unprecedented Heights. Welcome To A Story Where The True Victory Lies In Our Shared Success.
          </p>
          <div className="flex justify-center gap-4">
            <a href="#" className="p-3 bg-card hover:bg-accent hover:text-accent-foreground rounded transition-colors">
              X
            </a>
            <a href="#" className="p-3 bg-card hover:bg-accent hover:text-accent-foreground rounded transition-colors">
              in
            </a>
            <a href="#" className="p-3 bg-card hover:bg-accent hover:text-accent-foreground rounded transition-colors">
              IG
            </a>
            <a href="#" className="p-3 bg-card hover:bg-accent hover:text-accent-foreground rounded transition-colors">
              f
            </a>
            <a href="#" className="p-3 bg-card hover:bg-accent hover:text-accent-foreground rounded transition-colors">
              ★
            </a>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-foreground mb-2 text-center">
            From His Blog
          </h2>
          <p className="text-center text-muted-foreground mb-12">
            Dive Into The Blog For The Latest Updates, Expert Opinions, And Detailed Information On Our Projects.
          </p>

          <div className="grid md:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <BlogCard key={post.id} {...post} />
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <NewsletterSection />
    </>
  )
}
